import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "OprHistory" }

import {searchFormConfig} from '@/views/main/helper/oprHistory/config/search.config'
import {contentTableConfig} from '@/views/main/helper/oprHistory/config/content.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {usePageModal} from '@/hooks/usePageModal'
import dayjs from "dayjs";
import {useStore} from "@/store";
import {getListData} from "@/service/main/system";
import localCache from "@/utils/cache";
import {ElMessageBox, ElNotification} from "element-plus";
import useClipboard from "vue-clipboard3";


export default /*#__PURE__*/_defineComponent({
  __name: 'OprHistory',
  setup(__props) {

const { toClipboard } = useClipboard()
const store = useStore()

const getEmp = async () => {
  let userList = localCache.getCache('empData')
  const userOptions = userList.map((item: any) => {
    return {title: item.realName, value: item.id};
  })
  const userItem = searchFormConfig.formItems.find((item) => item.field === 'userid')
  userItem!.options = userOptions;
}
getEmp()

const getMenu = async () => {
  let menuList = await getListData('/main/oprHistory/queryMenu', {})
  const menuOptions = menuList.map((item: any) => {
    return {title: item, value: item};
  })
  const menuItem = searchFormConfig.formItems.find((item) => item.field === 'menu')
  menuItem!.options = menuOptions;
}
getMenu()

const queryParam = {
  timeSlot: [
    dayjs().subtract(1, 'weeks').startOf('date').format('YYYY-MM-DD'),
    dayjs().endOf('date').format('YYYY-MM-DD')
  ]
}
store.commit('system/changeQueyryInfo', queryParam)

const searchCb = () => {
  return queryParam
}

const resetCb = () => {
  return queryParam
}

const handleDownBtnClick = () => {
  const info = store.state.system.queryInfo
  let menu = '%%'
  let module = '%%'
  let func = '%%'
  let userid = '%%'
  if (info.menu != undefined && info.menu != '' && info.menu != null) {
    menu = info.menu
  }
  if (info.module != undefined && info.module != '' && info.module != null) {
    module = info.module
  }
  if (info.func != undefined && info.func != '' && info.func != null) {
    func = info.func
  }
  if (info.userid != undefined && info.userid != '' && info.userid != null) {
    userid = info.userid
  }

  const selectSql = `SELECT
  mk.menu AS 菜单名称,
  mk.module AS 模块名称,
  mk.func AS 功能名称,
  mk.api_abbr AS Api链接,
  log.opr_emp_name AS 访问人,
  log.opr_time AS 访问时间
FROM
  td_operation_log log
  JOIN api_mark mk ON mk.remark = log.opr_desc AND mk.api REGEXP log.request_url
WHERE
  log.opr_time BETWEEN '${info.timeSlot[0]} 00:00:00' AND '${info.timeSlot[1]} 23:59:59'
  AND mk.menu like '${menu}'
  AND mk.module like '${module}'
  AND mk.func like '${func}'
  AND log.opr_emp_id like '${userid}'`

  ElMessageBox.confirm(selectSql, '查询SQL语句', {
    dangerouslyUseHTMLString: true,
    confirmButtonText: '复制SQL语句',
    cancelButtonText: '取消'
  }).then(async () => {
    await toClipboard(selectSql)
    ElNotification({
      title: '复制成功',
      message: '',
      type: 'success'
    })
  })
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal()
const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch(searchCb, resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "oprHistory",
      downFilename: "功能使用明细.xlsx",
      onDownBtnClick: handleDownBtnClick
    }, null, 8, ["contentTableConfig"])
  ]))
}
}

})